import type {CondensedStatusRow} from '../../helpers/condensed-merge-status-presentation'
import styles from './MergeStatusRow.module.css'

export function MergeStatusRow({row}: {row: CondensedStatusRow}) {
  return (
    <div className={`${styles.row} text-small color-fg-muted`}>
      <span style={{color: row.iconColor}}>
        <row.icon size={16} />
      </span>
      <span>{row.label}</span>
      {row.detail ? <span className="color-fg-muted">{row.detail}</span> : null}
    </div>
  )
}
